import type jsPDF from "jspdf";
import { MONCO_URL } from "./constants";
import type { BrandHeader } from "./types";

export const buildLogoHeader = (
  doc: jsPDF,
  logoImage: HTMLImageElement,
  logoWidth: number,
): BrandHeader => {
  const aspectRatio = logoImage.naturalHeight / logoImage.naturalWidth;
  const logoHeight = logoWidth * aspectRatio;
  return {
    width: logoWidth,
    height: logoHeight,
    draw: (originX, originY) => {
      doc.addImage(logoImage, "PNG", originX, originY, logoWidth, logoHeight);
      doc.link(originX, originY, logoWidth, logoHeight, { url: MONCO_URL });
    },
  };
};
